import { useEffect, useState } from "react";

const usePageLeaveConfirmation = (unsavedChanges: boolean) => {
  const [promptOnPageLeave, setPromptOnPageLeave] = useState(unsavedChanges);

  useEffect(() => {
    const unloadHandler = (e: BeforeUnloadEvent) => {
      e.preventDefault();
    };

    if (promptOnPageLeave) {
      window.addEventListener("beforeunload", unloadHandler);
    } else {
      window.removeEventListener("beforeunload", unloadHandler);
    }

    return () => {
      window.removeEventListener("beforeunload", unloadHandler);
    };
  }, [unsavedChanges, promptOnPageLeave]);

  return { setPromptOnPageLeave };
};

export default usePageLeaveConfirmation;
